export default __webpack_public_path__ + "static/media/(24).91913a38.jpg";